<script>
import { cloneDeep } from 'lodash'
import SubscriptionPreferenceChannel from '@/modules/profiles/components/SubscriptionPreferenceChannel'

export default {
  name: 'SubscriptionPreferenceChannels',

  components: {
    SubscriptionPreferenceChannel
  },

  data() {
    return {
      currentChannel: {},
      displayMetadata: false
    }
  },

  props: {
    profileId: {
      type: String
    },

    preference: {
      type: Object,
      required: true
    },

    channelNames: {
      type: Array,
      required: false,
      default: []
    },

    withChannels: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    openAuditLog(channel) {
      this.currentChannel = channel
      window.localStorage.setItem(
        'audit_log_filter_sub_id',
        this.currentChannel.id
      )

      let filter =
        '{"field":"preferences.' + this.currentChannel.preference_name

      if (this.currentChannel.key) {
        filter += '.' + this.currentChannel.key
      }

      filter += '"}'

      this.$router.push({
        name: 'ProfileAuditLog',
        query: {
          project_id: this.$route.query.project_id,
          profile_num: this.$route.query.profile_num,
          profile_id: this.profileId,
          filters: filter
        }
      })
    }
  },

  computed: {
    resultChannels() {
      const preferenceName = this.preference.name || ''
      let channels = this.preference.channels || []

      channels.forEach(function(channel) {
        channel.preference_name = preferenceName
      })

      if (!this.withChannels) return channels

      const result = cloneDeep(this.channelNames)

      return result.map(function(c) {
        const channelData = channels.find(cd => cd.channel === c.key)
        c.metadata = null
        if (channelData) {
          c.id = channelData.id || undefined
          c.subscription = channelData.subscription
          c.preference_name = preferenceName
          c.metadata = channelData.metadata
        }

        return c
      })
    }
  }
}
</script>

<template>
  <div>
    <div class="consent-preference-channels">
      <subscription-preference-channel
        :key="index"
        v-for="(channel, index) in resultChannels"
        :channel="channel"
        @open-audit-log="openAuditLog"
        @reload-preferences="$emit('reload-preferences')"
      ></subscription-preference-channel>
    </div>
  </div>
</template>

<style scoped>
.consent-preference-channels {
  display: flex;
  gap: 15px;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/SubscriptionPreferenceChannels.vue